import React from "react";
import { HelmetProvider } from "react-helmet-async";
import LoadingAnimation from "./components/LoadingAnimation";
import { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import OfflinePage from "./pages/OfflinePage";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import axiosInstance from "./api/axiosInstance";
/* ---------------- CONTEXT ---------------- */
import { LocationProvider } from "./context/LocationContext";

/* ---------------- AUTH ---------------- */
import PrivateRoute from "./components/PrivateRoute";

/* ---------------- PUBLIC ---------------- */
import LoginPage from "./pages/LoginPage";
import CustomerSignup from "./pages/CustomerSignup";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import TermsAndConditions from "./pages/TermsAndConditions";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ProductDetailPage from "./pages/ProductDetailPage";


/* ---------------- CUSTOMER ---------------- */
import CategoryLandingPage from "./pages/CategoryLandingPage";
import CustomerDashboard from "./pages/CustomerDashboard";
import UploadPrescription from "./pages/UploadPrescription";
import MyPrescriptions from "./pages/MyPrescriptions";
import OrdersPage from "./pages/OrdersPage";
import ProfilePage from "./pages/ProfilePage";
import CartPage from "./pages/CartPage";
import ShopProducts from "./pages/ShopProducts";
import ShopMedicines from "./pages/ShopMedicines";
import ShopSurgical from "./pages/ShopSurgical";
import SettingsPage from "./pages/SettingsPage";
import CheckoutPage from "./pages/Checkout";
import PaymentPage from "./pages/PaymentPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import OrderTrackingPage from "./pages/OrderTrackingPage";
import SurgicalDashboard from "./pages/SurgicalDashboard";
import RxCheckoutPage from "./pages/RxCheckoutPage";
import PrescriptionHistoryPage from "./pages/PrescriptionHistoryPage"

/* ---------------- DELIVERY ---------------- */
import DeliveryDashboard from "./pages/DeliveryDashboard";
import AdminAssignDelivery from "./pages/AdminAssignDelivery";
import AdminDeliveryOrders from "./pages/AdminDeliveryOrders";
import AdminLiveMap from "./pages/AdminLiveMap";
import AdminAssignedOrders from "./pages/AdminAssignedOrders";
import AdminCourierOrders from "./pages/AdminCourierOrders";

import AdminDeliveryMonitor from "./pages/AdminDeliveryMonitor";
import AdminDeliveryBoyMap from "./pages/AdminDeliveryBoyMap";


/* ---------------- PHARMACIST ---------------- */
import PharmacistDashboard from "./pages/PharmacistDashboard";
import AdminPharmacists from "./pages/AdminPharmacists";
import PharmacistAvailabilityDashboard from "./pages/PharmacistAvailabilityDashboard";
import PharmacistPricingPage from "./pages/PharmacistPricingPage";
import PharmacistLayout from "./pages/PharmacistLayout";
import HospitalPharmacistDashboard from "./pages/HospitalPharmacistDashboard";

/* ---------------- ADMIN ---------------- */
import AdminDashboard from "./pages/AdminDashboard";
import MedicinePage from "./pages/MedicinePage";
import SurgicalPage from "./pages/SurgicalPage";
import AdminExcelUpload from "./pages/AdminExcelUpload";
import AdminSurgicalExcelPage from "./pages/AdminSurgicalExcelPage";
import AdminSurgicalExcelUpload from "./pages/AdminSurgicalExcelUpload";
import ProductPage from "./pages/ProductPage";
import AdminDeliveryCashSettlement from "./pages/AdminDeliveryCashSettlement";
import AdminSalarySettlement from "./pages/AdminSalarySettlement";
import AdminMonthlySalarySettlement from "./pages/AdminMonthlySalarySettlement";
import AdminMonthlySalarySettlementV2 from "./pages/AdminMonthlySalarySettlementV2";
import AdminBaseSalaryManagement from "./pages/AdminBaseSalaryManagement";
import AdminDeliveryNotes from "./pages/AdminDeliveryNotes";
import AdminEmergencyContact from "./pages/AdminEmergencyContact";
import AdminHospitals from "./pages/AdminHospitals";
import PharmacistRxDashboard from "./pages/PharmacistRxDashboard";
import AdminRxPanel from "./pages/AdminRxPanel";
import InternalPharmacistDashboard from "./pages/InternalPharmacistDashboard";
import { LoadScript } from "@react-google-maps/api";

import AdminHospitalSettlementPage from "./pages/AdminHospitalSettlementPage";
import AdminConsumerExcelUpload from "./pages/AdminConsumerExcelUpload";
import AdminConsumerProducts from "./pages/AdminConsumerProducts";
import {requestNotificationPermission} from "./utils/notifications";
import NotificationsPage from "./pages/NotificationsPage";
import ConsumerProductPage from "./pages/ConsumerProductPage";
import CategoryProducts from "./pages/CategoryProducts";
import AdminCoupons from "./pages/AdminCoupons";
import RequestedMedicines from "./pages/RequestedMedicines";
import PharmacistApproval from "./pages/PharmacistApproval";
import OrderDashboard from "./pages/OrderDashboard";
import DashboardOrders from "./pages/DashboardOrders";
import NewCheckoutPage from "./pages/NewCheckoutPage";
import HomeRedirect from "./pages/HomeRedirect";
import DeleteAccountPage from "./pages/DeleteAccountPage";
import IntroPage from "./pages/IntroPage";
/* ---------------- SUPER ADMIN ---------------- */
import SuperAdminUsers from "./pages/SuperAdminUsers";
import AdminOrderDetail from "./pages/AdminOrderDetail";
import AdminDeliveryConfig from "./pages/AdminDeliveryConfig";
import PickupOrderPage from "./pages/PickupOrderPage";
import FeedbackPage from "./pages/FeedbackPage";
import PullToRefresh from "react-simple-pull-to-refresh";
import HomeRedirect1 from "./pages/HomeRedirect1";
import GenericMedicines from "./pages/GenericMedicines";
import SearchAnalyticsPage from "./pages/SearchAnalyticsPage";
import AdminSendCouponPage from "./pages/AdminSendCouponPage";
import RefundCancellationPolicy from "./pages/RefundCancellationPolicy";
import PublicCustomerDashboard from "./pages/PublicCustomerDashboard";
import PublicShopSurgical from "./pages/PublicShopSurgical";
import PublicCategoryProducts from "./pages/PublicCategoryProducts";
import PublicGenericMedicines from "./pages/PublicGenericMedicines";
import PublicShopProducts from "./pages/PublicShopProducts";




function App() {
const libraries = ["places"];
const userRole = localStorage.getItem("userRole");
useEffect(() => {
  if (!window.__FCM_INIT__) {
    window.__FCM_INIT__ = true;
    requestNotificationPermission();
  }
}, []);
const [updateAvailable, setUpdateAvailable] = useState(false);
const [loading, setLoading] = useState(true);
useEffect(() => {
  const init = async () => {
    // abhi ke liye simple delay
    await new Promise(res => setTimeout(res, 1500));

    setLoading(false);
  };

  init();
}, []);







useEffect(() => {

  const handleUpdate = () => {
    console.log("🚀 New version available");
    setUpdateAvailable(true);
  };

  window.addEventListener("appUpdate", handleUpdate);

  return () => {
    window.removeEventListener("appUpdate", handleUpdate);
  };

}, []);
const handleRefresh = () => {
  window.dispatchEvent(new Event("appRefresh"));
  return Promise.resolve();
};

if (loading) {
  return <LoadingAnimation />;
}
  return (
<HelmetProvider>
<>
    
      <LocationProvider>
        <Toaster position="top-center" />
      <LoadScript
        googleMapsApiKey={process.env.REACT_APP_GOOGLE_PLACES_API_KEY}
        libraries={libraries}
      >
<PullToRefresh onRefresh={handleRefresh}>
<Router>
        <Routes>
          {/* ================= PUBLIC ================= */}
          <Route
  path="/product/:productType/:productSlug"
  element={<ProductDetailPage />}
/>

<Route
  path="/product/:productSlug"
  element={<ProductDetailPage />}
/>
				

          <Route path="/signup-customer" element={<CustomerSignup />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
<Route path="/about" element={<AboutPage />} />
<Route path="/contact" element={<ContactPage />} />
<Route path="/privacy" element={<PrivacyPolicy />} />
<Route path="/login" element={<LoginPage />} />

<Route path="/public-customer" element={<PublicCustomerDashboard />} />
<Route path="/home" element={<HomeRedirect />} />
<Route path="/" element={<IntroPage />} />

<Route path="/public-Surgical" element={<PublicShopSurgical />} />

<Route path="/public-generic" element={<PublicGenericMedicines />} />

<Route path="/public/:category" element={<PublicCategoryProducts />} />


<Route path="/public-shop" element={<PublicShopProducts />} />



<Route path="/offline" element={<OfflinePage />} />
<Route
  path="/search-analytics"
  element={<SearchAnalyticsPage />}
/>

<Route
  path="/refund-cancellation-policy"
  element={<RefundCancellationPolicy />}
/>
          {/* ================= CUSTOMER ================= */}
          <Route
            path="/category-landing"
            element={
              <PrivateRoute allowedRoles={["patient"]}>
                <CategoryLandingPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/customer-dashboard"
            element={
              <PrivateRoute allowedRoles={["patient"]}>
                <CustomerDashboard />
              </PrivateRoute>
            }
          />


          <Route
            path="/upload-prescription"
            element={
              <PrivateRoute allowedRoles={["patient"]}>
                <UploadPrescription />
              </PrivateRoute>
            }
          />
<Route path="/prescriptions" element={
  <PrivateRoute allowedRoles={["patient"]}>
    <PrescriptionHistoryPage />
  </PrivateRoute>
} />

         
        

<Route
  path="/orders"
  element={<OrdersPage />}
/>


<Route
  path="/FeedbackPage"
  element={<FeedbackPage />}
/>



<Route
  path="/generic-medicines"
  element={<GenericMedicines />}
/>


          <Route
            path="/profile"
            element={
              <PrivateRoute allowedRoles={["patient"]}>
                <ProfilePage />
              </PrivateRoute>
            }
          />

          <Route
            path="/cart"
            element={
              <PrivateRoute allowedRoles={["patient"]}>
                <CartPage />
              </PrivateRoute>
            }
          />

          <Route path="/products" element={<ShopProducts />} />

          <Route
            path="/shop-medicines"
            element={
              <PrivateRoute allowedRoles={["patient", "admin"]}>
                <ShopMedicines />
              </PrivateRoute>
            }
          />

          <Route
            path="/shop-surgical"
            element={
              <PrivateRoute allowedRoles={["patient", "admin"]}>
                <ShopSurgical />
              </PrivateRoute>
            }
          />

          <Route
            path="/settings"
            element={
              <PrivateRoute allowedRoles={["patient"]}>
                <SettingsPage />
              </PrivateRoute>
            }
          />
<Route
  path="/checkout"
  element={
    <PrivateRoute allowedRoles={["customer", "patient"]}>
      <CheckoutPage />
    </PrivateRoute>
  }
/>
<Route
  path="/rx-checkout/:rxId"
  element={
    <PrivateRoute allowedRoles={["patient"]}>
      <RxCheckoutPage />
    </PrivateRoute>
  }
/>

          <Route
            path="/payment/:orderId"
            element={
              <PrivateRoute allowedRoles={["patient"]}>
                <PaymentPage />
              </PrivateRoute>
            }
          />

          <Route
 path="/payment-success"
 element={<PaymentSuccess />}
/>

          <Route
            path="/track-order/:orderId"
            element={
              <PrivateRoute allowedRoles={["patient"]}>
                <OrderTrackingPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/surgical-dashboard"
            element={
              <PrivateRoute allowedRoles={["patient"]}>
                <SurgicalDashboard />
              </PrivateRoute>
            }
          />
<Route
  path="/requested-medicines"
  element={<RequestedMedicines />}
/>


<Route
  path="/dashboard"
  element={<OrderDashboard />}
/>
<Route
  path="/dashboard/orders/:status"
  element={<DashboardOrders />}
/>
<Route
  path="/admin/orders"
  element={<AdminOrderDetail />}
/>


          {/* ================= DELIVERY ================= */}
          <Route
            path="/delivery"
            element={
              <PrivateRoute allowedRoles={["delivery"]}>
                <DeliveryDashboard />
              </PrivateRoute>
            }
          />
<Route
  path="/admin/assigned-orders"
  element={
    <PrivateRoute allowedRoles={["admin", "superadmin"]}>
      <AdminAssignedOrders />
    </PrivateRoute>
  }
/>

<Route
  path="/admin/delivery_orders"
  element={
    <PrivateRoute allowedRoles={["admin", "superadmin"]}>
      <AdminDeliveryOrders />
    </PrivateRoute>
  }
/>
<Route
  path="/admin/live-map/:orderId"
  element={
    <PrivateRoute allowedRoles={["admin", "superadmin"]}>
      <AdminLiveMap />
    </PrivateRoute>
  }
/>

<Route path="/delete-account" element={<DeleteAccountPage />} />

<Route
  path="/admin/delivery-monitor"
  element={
    <PrivateRoute allowedRoles={["admin", "superadmin"]}>
      <AdminDeliveryMonitor />
    </PrivateRoute>
  }
/>
<Route
  path="/admin/delivery-boy-map/:boyId"
  element={
    <PrivateRoute allowedRoles={["admin", "superadmin"]}>
      <AdminDeliveryBoyMap />
    </PrivateRoute>
  }
/>
<Route path="/admin/delivery-cash-settlement" element={<AdminDeliveryCashSettlement />} />
<Route
  path="/admin/salary-settlement"
  element={<AdminSalarySettlement />}
/>

<Route path="/admin/monthly-salary" element={<AdminMonthlySalarySettlement />} />
<Route
  path="/admin/monthly-salary-v2"
  element={
    <PrivateRoute allowedRoles={["admin", "superadmin"]}>
      <AdminMonthlySalarySettlementV2 />
    </PrivateRoute>
  }
/>
<Route
  path="/admin/base-salary"
  element={<AdminBaseSalaryManagement />}
/>
<Route
  path="/admin/delivery-notes"
  element={<AdminDeliveryNotes />}
/>

          {/* ================= PHARMACIST ================= */}
          <Route
            path="/pharmacist"
            element={
              <PrivateRoute allowedRoles={["pharmacist"]}>
                <PharmacistDashboard />
              </PrivateRoute>
            }
          />
<Route path="/internal-pharmacist" element={<InternalPharmacistDashboard />} />

<Route
  path="/admin/Hospitals"
  element={
    <PrivateRoute allowedRoles={["admin", "superadmin"]}>
      <AdminHospitals/>
    </PrivateRoute>
  }
/>

<Route 
 path="/admin/Pharmacists"
   element={
   <PrivateRoute allowedRoles={["admin", "superadmin"]}>
  <AdminPharmacists/>
  </PrivateRoute>
 }
 />
<Route path="/admin/emergency-contact" element={<AdminEmergencyContact />} />
<Route path="/Pharmacist/Availability-Dashboard" element={<PharmacistAvailabilityDashboard/>}/>	

	      <Route
        path="/admin/rx-panel"
        element={<AdminRxPanel />}
      />

<Route
  path="/pharmacist/*"
  element={
    <PrivateRoute allowedRoles={["pharmacist", "hospitalpharmacist"]}>
      <PharmacistLayout />
    </PrivateRoute>
  }
>
  <Route path="rx-dashboard" element={<PharmacistRxDashboard />} />
  <Route path="pricing/:requestId" element={<PharmacistPricingPage />} />
</Route>
<Route
  path="/hospital-pharmacist"
  element={
    userRole === "hospitalpharmacist"
      ? <HospitalPharmacistDashboard />
      : <Navigate to="/login" />
  }
/>
<Route path="/notifications" element={<NotificationsPage />} />

<Route
  path="/newcheckout/:orderId"
  element={
    <PrivateRoute allowedRoles={["patient"]}>
      <NewCheckoutPage />
    </PrivateRoute>
  }
/>
<Route
  path="/admin/delivery-config"
  element={<AdminDeliveryConfig />}
/>




          {/* ================= ADMIN ================= */}
<Route
  path="/admin/send-coupon"
  element={<AdminSendCouponPage />}
/>       


   <Route
            path="/admin"
            element={
              <PrivateRoute allowedRoles={["admin"]}>
                <AdminDashboard />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/medicine"
            element={
              <PrivateRoute allowedRoles={["admin"]}>
                <MedicinePage />
              </PrivateRoute>
            }
          />

        
          <Route
            path="/admin/surgical/:id"
            element={
              <PrivateRoute allowedRoles={["admin"]}>
                <SurgicalPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/surgical"
            element={
              <PrivateRoute allowedRoles={["admin"]}>
                <SurgicalPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/surgical-excel"
            element={
              <PrivateRoute allowedRoles={["admin"]}>
                <AdminSurgicalExcelPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/upload-surgical-excel"
            element={
              <PrivateRoute allowedRoles={["admin"]}>
                <AdminSurgicalExcelUpload />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/upload-excel"
            element={
              <PrivateRoute allowedRoles={["admin"]}>
                <AdminExcelUpload />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/products"
            element={
              <PrivateRoute allowedRoles={["admin"]}>
                <ProductPage />
              </PrivateRoute>
            }
          />


 <Route
  path="/admin/hospital-settlements"
  element={
    <PrivateRoute role={["admin", "superadmin"]}>
      <AdminHospitalSettlementPage />
    </PrivateRoute>
  }
/>

<Route
  path="/admin/consumer-products"
  element={
    <PrivateRoute allowedRoles={["admin", "superadmin"]}>
      <AdminConsumerExcelUpload />
    </PrivateRoute>
  }
/>

<Route
  path="/admin/consumer-products-list"
  element={
    <PrivateRoute allowedRoles={["admin", "superadmin"]}>
      <AdminConsumerProducts />
    </PrivateRoute>
  }
/>
<Route path="/admin/consumer" element={<ConsumerProductPage />} />
<Route path="/admin/consumer/:id" element={<ConsumerProductPage />} />
<Route path="/products/:category" element={<CategoryProducts />} />
<Route path="/admin/coupons" element={<AdminCoupons />} />
<Route
  path="/pharmacist/approvals"
  element={<PharmacistApproval />}
/>
<Route
  path="/admin/courier-orders"
  element={<AdminCourierOrders />}
/>

<Route path="/pickup-order/:orderId" element={<PickupOrderPage />} />

          {/* ================= SUPER ADMIN ================= */}
          <Route
            path="/super-admin"
            element={
              <PrivateRoute allowedRoles={["superadmin"]}>
                <SuperAdminUsers />
              </PrivateRoute>
            }
          />

          {/* ================= FALLBACK ================= */}
          <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
</PullToRefresh>
      </LoadScript>
{updateAvailable && (
  <button
    onClick={() => window.location.reload()}
    style={{
      position: "fixed",
      bottom: "20px",
      left: "50%",
      transform: "translateX(-50%)",
      padding: "8px 16px",
      background: "#2563eb",
      color: "#fff",
      border: "none",
      borderRadius: "6px",
      zIndex: 9999
    }}
  >
    🚀 Update App
  </button>
)}
</LocationProvider>


  </>
</HelmetProvider>

  );
}

export default App;
